var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartlyCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6673_5518",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00585938,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6673_5518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26829 8.49889L4.62444 8.47515L4.71767 8.1306C5.00867 7.05517 5.58887 6.18684 6.4671 5.51079C7.34149 4.8377 8.34785 4.5 9.50586 4.5C10.8115 4.5 11.9342 4.93591 12.8976 5.8169C13.8625 6.69931 14.3941 7.76821 14.5078 9.04438L14.5484 9.5H15.0059C15.847 9.5 16.5458 9.78866 17.1315 10.3744C17.7172 10.9601 18.0059 11.6589 18.0059 12.5C18.0059 13.3411 17.7172 14.0399 17.1315 14.6256C16.5458 15.2113 15.847 15.5 15.0059 15.5H4.50586C3.52584 15.5 2.70902 15.1627 2.02608 14.4798C1.34313 13.7968 1.00586 12.98 1.00586 12C1.00586 11.0715 1.31859 10.2805 1.95406 9.60228C2.59078 8.92271 3.35471 8.5598 4.26829 8.49889Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloud);
export default __webpack_public_path__ + "static/media/partly-cloud.7bf63ef5651a65357e848e5314bbead7.svg";
export { ForwardRef as ReactComponent };